import { Component, OnInit, Inject, ViewChild, Input     } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { GuidedCreation                } from 'src/app/beans/guided-creation/guided.creation.bean';
import { GuidedCreation2 } from 'src/app/beans/guidedCreation2/guidedCreation2';
import { User } from 'src/app/beans/login/user/user.bean';
import { Result } from 'src/app/beans/result/result.bean';
import { StepperModule1 } from 'src/app/components/stepper-module/module.1/module.1.component';
import { StepperModule2 } from 'src/app/components/stepper-module/module.2/module.2.component';
import { StepperModule3 } from 'src/app/components/stepper-module/module.3/module.3.component';
import { DialogsReturnCode             } from 'src/app/enums/dialogs/returnCode.enum';
import { isSessionCode } from 'src/app/enums/session/session-code.enum';
import { HandlerManager } from 'src/app/managers/handler/handler.manager';
import { LoadingManager } from 'src/app/managers/loading/loading.manager';
import { SessionManager                } from 'src/app/managers/session/session.manager';

@Component
({
  selector: 'stepper-dialog',
  templateUrl: './stepper.dialog.html',
  styleUrls: ['./stepper.dialog.scss'],
})

export class StepperDialog implements OnInit 
{

  orgId: number = null

  cancel_text : string = "dialog.generic.cancel"

  module_number: number = 2
  module_total : number = 3

  quick_type: "org" | "site" = "org"

  isNextModule: number = 0

  @ViewChild("StepperModule1") module1: StepperModule1
  @ViewChild("StepperModule2") module2: StepperModule2
  @ViewChild("StepperModule3") module3: StepperModule3

  constructor
  (
    private dialogRef : MatDialogRef<StepperDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any      ,
    private _session: SessionManager               ,
    private _loader : LoadingManager               ,
    private _handler: HandlerManager                  
  ) {}

  ngOnInit(): void
  {
    this.module_number  = this.data.step
    this.quick_type     = this.data.quick_type
    
    this.orgId          = this.data.orgId
  }

  //---------------------------------------------------------------------------------------------------
  
  cancel()
  {
    this._session.guidedCreation().clear()
    this.dialogRef.close
    ( 
      {
        code: DialogsReturnCode.OPERATION_DECLINED
      }
    )
  }

  previousModule()
  {
    if(this.module_number > 1) this.module_number--
  }

  nextModule(value: number)
  {
    if(value == 1)
    {
      if(this.module_number == 3) this.continue()
      
      if(this.module_number != this.module_total)
      {
        this.module_number++
      }
    }
  }

  sayNextModule()
  {
    switch(this.module_number) 
    {
      case 1: this.module1.checkInput(); break;
      case 2: this.module2.checkInput(); break;
      case 3: this.module3.checkInput(); break;
    }
  }

  async continue()
  {
    let gCreation = this._session.guidedCreation().get() as GuidedCreation

    console.log(gCreation);

    if(gCreation && !isSessionCode(gCreation))
    {
      let response = await this.create(gCreation)

      if(response && Result.isKind(response) && response.result == 1)
      {
        this._session.guidedCreation().clear()
        this.dialogRef.close
        ( 
          {
            code: DialogsReturnCode.OPERATION_ACCEPTED
          }
        )
      }
    }
  }

  async create(gCreation: GuidedCreation)
  { 
    
    gCreation.stima = (gCreation.stima) ? "Y" : "N"

    const user = this._session.user().get()

    if(!User.isKind(user)) return // TODO handle user incorrect 

    // interfacciamento servizio di Bonetti
    
    const pharma2 = GuidedCreation2.fromGuidedCreation( gCreation ) 
    console.log( JSON.stringify(pharma2) );
    
    //Get hubId from session (saved after login)
    // let hub: Hub
    // try{ hub = JSON.parse(this._session.hub().get()) as Hub}
    // catch(exeption){}

    this._loader.start()


    let response = null
    response = await this._handler.hub().createComplete((user as User).token, pharma2, this.orgId)

    console.log(response);

    this._loader.stop()

    if(!response) return

    return response;
  }

  canGoBack(){
    switch( this.quick_type )
    {
      case "org": return this.module_number  > 1
      case "site": return this.module_number  > 2
    }
  }
}
